import axios from "axios";
import { projectUrl } from "../../utils";

export const fetchProject = async (id: string) => {
  return await axios.get(projectUrl(id));
};
